function useSubUrl() {
	const suburl = localStorage.getItem('suburl');

	return suburl;
}

export default useSubUrl;
